import './MyFavClub.css';
import { useState, useEffect, useCallback } from 'react';
import { LuMapPin, LuStar, LuPercent, LuNavigation } from 'react-icons/lu';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function MyFavClub() {
    const [favList, setFavList] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        const userData = localStorage.getItem('userData');
        if (!userData) {
            navigate('/login');
        }
    }, [navigate]);

    const userdata = JSON.parse(localStorage.getItem("userData"));
    const url = "https://partywitty.com/master/assets/uploads/";

    const fetchEvents = async (lat, lng) => {
        const formData = new FormData();
        formData.append("latitude", lat);
        formData.append("longitude", lng);
        formData.append("user_id", userdata?.id || "");
        setLoading(true);
        try {
            const response = await axios.post(
                "https://partywitty.com/master/APIs/Common/favList",
                formData
            );

            if (response.data?.data) {
                setFavList(response.data.data);
            } else {
                console.error("Invalid response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching event details:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude(latitude.toString());
                    setLongitude(longitude.toString());
                    fetchEvents(latitude, longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    setLoading(false);
                }
            );
        } else {
            setLoading(false);
        }
    }, []);

    const generateClubUrl = useCallback((clubName, cityName, areaName) => {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");
        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }, []);

    if (loading) {
        return (
            <div className='fav-club-section'>
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading your favorite clubs...</p>
            </div>
            </div>
        );
    }

    return (
        <div className='fav-club-section'>
            <div className="fav-club-container">
                <div className="fav-club-header">
                    <h2>My Favorite Clubs</h2>
                </div>

                {favList.length > 0 ? (
                    <div className="my-fav-club-grid">
                        {favList.map((clubitem) => (
                            <Link to={generateClubUrl(clubitem.clubName, clubitem.cityName, clubitem.areaName)}>
                                <div key={clubitem.id} className="my-fav-club-card">
                                    <div className="my-fav-club-image-container">
                                        <img
                                            src={clubitem.clubLogo ? `${url}${clubitem.clubLogo}` : '/api/placeholder/300/200'}
                                            alt={clubitem.clubName}
                                            className="my-fav-club-image"
                                            onError={(e) => {
                                                e.target.src = '/api/placeholder/300/200';
                                            }}
                                        />
                                        {clubitem.discount > 0 && (
                                            <>
                                                <div className="my-fav-discount-badge">
                                                    <LuPercent size={12} />
                                                    {clubitem.discount}% OFF
                                                </div>
                                            </>
                                        )}
                                        <div className="my-fav-category-badge">{clubitem.category}</div>
                                    </div>

                                    <div className="my-fav-club-content">
                                        <h3 className="my-fav-club-name">
                                            {clubitem.clubName.length > 16
                                                ? `${clubitem.clubName.slice(0, 16)}...`
                                                : clubitem.clubName}
                                        </h3>

                                        <span className="my-fav-addon-text">+{clubitem.addon} addons available</span>

                                        <div className="my-fav-club-address">
                                            {clubitem.address?.replace(/\r\n/g, '').trim()}
                                        </div>

                                        <div className="my-fav-club-stats">
                                            <div className="my-fav-rating-section">
                                                <span className="my-fav-rating-text">
                                                    {parseFloat(clubitem.totalAverageRating || 0).toFixed(1)} ({clubitem.totalRating || 0} reviews)
                                                </span>
                                            </div>

                                            <div className="my-fav-distance-section">
                                                <LuNavigation size={14} />
                                                <span>{parseFloat(clubitem.distance || 0).toFixed(2)} km away</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                ) : (
                    <div className="my-fav-no-clubs">
                        <h3>No favorite clubs yet</h3>
                        <p>Start exploring and add clubs to your favorites!</p>
                    </div>
                )}
            </div>
        </div>
    );
}
